import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import {
  CompanySettings,
  companySettingsSchema,
} from '../schemas/company-settings.schema';
import { createRequestEnumPreprocessor } from '../../../utils/create-request-enum-preprocessor';
import { unitsOfMeasurementOptions } from '../../../schemas/units-of-measurement.schema';
import { parseRequestSchema } from '../../../utils/parse-request-schema';
import { ignoreData } from '../../../utils/ignore-data';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';

const requestSchema = companySettingsSchema.extend({
  units: createRequestEnumPreprocessor(unitsOfMeasurementOptions),
});

/**
 * Updates your company settings
 * @param companySettings Updated Company Settings
 * @returns 200 Response
 */
export function postCompanySettings(
  this: unknown,
  companySettings: CompanySettings
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).companyUrl}/settings`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: parseRequestSchema(requestSchema, companySettings),
      })
    )
  ).pipe(ignoreData());
}
